import {
    BrandVariants,
    GriffelStyle,
    Theme,
    createDarkTheme,
    createLightTheme,
    makeStyles,
    themeToTokensObject,
    tokens,
} from '@fluentui/react-components';

export const semanticKernelBrandRamp: BrandVariants = {
    10: '#002D5C',
    20: '#00426B',
    30: '#00587A',
    40: '#006E89',
    50: '#108497',
    60: '#219BA5',
    70: '#31B2B3',
    80: '#42C9C2',
    90: '#51CDC7',
    100: '#60D2CC',
    110: '#6FD7D1',
    120: '#7FDCD6',
    130: '#8EE0DB',
    140: '#9DE5E0',
    150: '#ACEAE5',
    160: '#BCEFEB',
};

const candcBrandRamp: BrandVariants = {
    10: '#002D5C',
    20: '#00426B',
    30: '#00587A',
    40: '#006E89',
    50: '#108497',
    60: '#219BA5',
    70: '#31B2B3',
    80: '#42C9C2',
    90: '#51CDC7',
    100: '#60D2CC',
    110: '#6FD7D1',
    120: '#7FDCD6',
    130: '#8EE0DB',
    140: '#9DE5E0',
    150: '#ACEAE5',
    160: '#BCEFEB',
};

export const semanticKernelLightTheme: Theme & { colorMeBackground: string } = {
    ...createLightTheme(semanticKernelBrandRamp),
    colorMeBackground: '#fa450d',
};

export const semanticKernelDarkTheme: Theme & { colorMeBackground: string } = {
    ...createDarkTheme(semanticKernelBrandRamp),
    colorMeBackground: '#fa450d',
};

export const candcLightTheme: Theme & { colorMeBackground: string } = {
    ...createLightTheme(candcBrandRamp),
    colorMeBackground: '#fa450d',
};

export const candcDarkTheme: Theme & { colorMeBackground: string } = {
    ...createDarkTheme(candcBrandRamp),
    colorMeBackground: '#fa450d',
};

export const customTokens = themeToTokensObject(candcLightTheme);

export const Breakpoints = {
    small: (style: GriffelStyle): Record<string, GriffelStyle> => {
        return { '@media (max-width: 744px)': style };
    },
};

export const ScrollBarStyles: GriffelStyle = {
    overflowY: 'scroll',
    '&:hover': {
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: tokens.colorScrollbarOverlay,
            visibility: 'visible',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: tokens.colorNeutralBackground1,
            WebkitBoxShadow: 'inset 0 0 5px rgba(0, 0, 0, 0.1)',
            visibility: 'visible',
        },
    },
};

export const SharedStyles: Record<string, GriffelStyle> = {
    scroll: {
        height: '100%',
        ...ScrollBarStyles,
    },
};

export const useDialogClasses = makeStyles({
    root: {
        height: '515px',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: '10px',
    },
    scopes: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: '5px',
        paddingLeft: '20px',
    },
    error: {
        color: '#d13438',
    },
    section: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        rowGap: '10px',
    },
    footer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        minWidth: '175px',
    },
});
